/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React, { useState } from "react";

import { NavLink } from "react-router-dom";
import { bem } from "../shared/BEM";

/**
 * Model list entry
 */
export interface IModelListEntry {
	/** Model route */
	route: string;

	/** MDI icon */
	icon: string;

	/** Title */
	title: string;

	/** Description */
	description: string;

	/** Version */
	version: string;
}

/**
 * Component props
 */
export interface IModelListProps {
	models: Array<IModelListEntry>;
}

/**
 * Displays a list of models
 *
 * @param props Props
 */
export function ModelList(props: IModelListProps) {

	const style = bem("model-list");

	return <div className={style.className()}>
		<ul className={style.el("list").className()}>
			{props.models.map((item: IModelListEntry) =>
				<li className={style.el("item").className()} key={item.route}>
					<NavLink to={item.route}>
						<span className={style.el("item-title").className()}>
							<i className={`mdi mdi-${item.icon}`} /><span>{item.title}</span>
						</span>
						<span className={style.el("item-description").className()}>{item.description}</span>
						<span className={style.el("item-version").className()}>Verze {item.version}</span>
					</NavLink>
				</li>
			)}
		</ul>
	</div>;

}
